// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#2196f3' },
    text: {
      primary: '#1C2A42',
      secondary: 'rgba(28,42,66,0.7)',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        caption: {
          color: 'rgba(28,42,66,0.7)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: 'rgba(28,42,66,0.5)',
          },
        },
        root: {
          '&.Mui-focused': {
            outline: '2px solid #2196f3',
            outlineOffset: '2px',
          },
        },
      },
    },  
    MuiButtonBase: {
        styleOverrides: {
          root: {
            '&:focus-visible': {
              outline: '2px solid #2196f3',
              outlineOffset: '2px',
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            '&:focus-visible': {
              outline: '2px solid #2196f3',
              outlineOffset: '2px',
            },
          },
        },
      },
    },
  });

export default theme;
